import {QueryClient} from 'react-query';

import {
  getNotifications,
  getNotificationsQueryKey,
} from '../server/react-query/useNotification';
import {setWebAppBadge} from './web-app-badge.utils';

export const hashNotificationId = (value: string) => value;

export const removeNotificationFromTray = () => undefined;
export const clearDeliveredAndroidNotifications = () => undefined;
export const clearDeliveredAppNotifications = () => undefined;
export const removeDeliveredNotificationsByText = () => undefined;

export const applyNotificationBadgeCount = async (unreadCount?: number) => {
  const normalizedCount = Math.max(0, Number(unreadCount) || 0);
  await setWebAppBadge(normalizedCount);
  return normalizedCount;
};

export const syncUnreadNotificationIndicators = async (
  queryClient: QueryClient,
  patientId?: string,
) => {
  await queryClient.invalidateQueries('get-notifications');
  await queryClient.invalidateQueries('service-request-count');

  const notifications = await queryClient.fetchQuery(
    getNotificationsQueryKey(patientId || ''),
    () =>
      getNotifications({
        pageNumber: 1,
        pageSize: 1000,
        patientId: patientId || '',
      }),
  );

  return applyNotificationBadgeCount(notifications?.totalUnread ?? 0);
};
